// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/es6.object.assign.js
// module id = 135
// module chunks = 2 3 6 7 8 10 11 12 13 14 17 21 22 23 25 26 27 28 29 31 32 33 34 35 36 37 38 40 45 51